module.exports = __webpack_public_path__ + "img/17.12141046.svg";